import { createThunk, model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { Api, ISearchCommonResponse } from '@api';
import { ThunkAbortController } from '../utils';
import { useRoot } from '../useRoot';
import { SearchUserListModel } from './SearchUserListModel';
import { SearchTutorialListModel } from './SearchTutorialListModel';

export class Search extends Model({
  videos: types.optional(SearchTutorialListModel, {}),
  users: types.optional(SearchUserListModel, {}),
}) {
  get isEmpty() {
    return this.videos.isEmpty && this.users.isEmpty;
  }

  private _updateModel(newData: ISearchCommonResponse) {
    this.videos.set(newData.videos);
    this.users.set(newData.users);
  }

  private _fetchAbortController = new ThunkAbortController();

  fetch = createThunk((queryParam: string) => {
    return async function fetch(this: Search) {
      try {
        // Cancel previous request if it in progress
        this._fetchAbortController.abort();

        const res = await Api.Search.searchCommon(
          {
            query: queryParam,
          },
          this._fetchAbortController.create(),
        );

        this._updateModel(res.data);

        this._fetchAbortController.remove();

        return res.data;
      } catch (error) {
        // If request was canceled do nothing
        if (ThunkAbortController.isCanceled(error)) {
          return;
        }

        throw error;
      }
    };
  });
}

export const SearchModel = model(Search);

export function useSearchModel() {
  const root = useRoot();

  return root.search;
}
